import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import Latlng from '../js/latlng';
import mapUtil from '../js/mapUtil';
import util from '../../../common/util';
import { HereMarker } from '@/components/map/hook/useMarkerClass';

import numberFormat, {
    formatNumberForFixed
} from '@/common/format/number-format';
export default {
    emits: ['markerReady', 'update:active'],
    i18next: {
        ns: 'md-house'
    },
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        events: {
            type: Object,
            default: () => ({})
        },
        active: {
            type: String,
            default: ''
        }
    },
    inject: ['applyMap'],
    data: function() {
        return {
            popStyle: {},
            pointerStyle: {},
            popBottom: false,
            parentDom: null
        };
    },

    computed: {
        ...rootMapState(usePageStore, {
            "wordPressSSR": store => store.page.wordPressSSR
        }),
        lat() {
            return Latlng.getLatitude(this.data);
        },
        lng() {
            return Latlng.getLongitude(this.data);
        },
        fmLatlng() {
            return Latlng.format(this.data);
        },
        
        showPlus({ data }) {
            return data?.items?.length > 1;
        },
        keepFixed({ data }) {
            let fixedNum = 0;
            let priceFormat = numberFormat(data.price, true, 0);
            if (priceFormat.indexOf('M') > -1) {
                fixedNum = 1;
            }
            return fixedNum;
        },
        showPrice({ data, keepFixed, showPlus }) {
            if (showPlus) {
                return formatNumberForFixed(data.price, true, keepFixed) + '+';
            } else {
                return numberFormat(data.price, true, keepFixed);
            }
        }
    },
    watch: {
        active(value) {
            const parentEl = this.$refs.markerRef && this.$refs.markerRef.parentNode;
            if (parentEl && parentEl.classList.contains('marker-dom')) {
                parentEl.classList[value === this.fmLatlng ? 'add' : 'remove'](
                    'active'
                );
            }
            value === this.fmLatlng &&
                this.$nextTick(() => {
                    this.onActive();
                });
        }
    },
    mounted() {
        this.applyMap(([map]) => {
            !this.mapMarker &&
                this.lat &&
                this.lng &&
                (this.mapMarker = new HereMarker(
                    {
                        isVueRef: false,
                        map,
                        lat: this.lat,
                        lng: this.lng,
                        marker: this,
                        onready: () => {
                            this.$emit('markerReady');
                        },
                        markerClassName: this.markerClassName || ''
                    }
                ));
        });
        const $pop = this.$refs.pop;
        if ($pop) {
            const wheelFn = function(evt) {
                evt.stopPropagation();
            };
            $pop.addEventListener('mousewheel', wheelFn, {
                passive: false
            });
            $pop.addEventListener('DOMMouseScroll', wheelFn, false);
            $pop.addEventListener('wheel', wheelFn, false);
        }
    },
    unmounted() {
        this.mapMarker && this.mapMarker.destroy && this.mapMarker.destroy();
    },
    methods: {
        transformLink2WordPress(link) {
            return util.transformLink2WordPress(link, this.wordPressSSR);
        },
        onActive() {
            this.applyMap(([map, maps, siteMap]) => {
                if (!this.lat || !this.lng) {
                    return; 
                }
                const popStyle = {};
                const pointerStyle = {};
                const $pop = this.$refs.pop;
                const $pointer = this.$refs.popinter;
                const mapBounds = mapUtil.getBounds(map);
                if (!mapUtil.pointInbound(+this.lng, +this.lat, mapBounds)) {
                    popStyle.left = '';
                    pointerStyle.left = '';
                    map.setCenter({
                        lat: +this.lat,
                        lng: +this.lng
                    });
                    this.popStyle = popStyle;
                    this.pointerStyle = pointerStyle;
                    return;
                }
                const mapWidth = (siteMap.$el && siteMap.$el.offsetWidth) || 0;
                const mapHeight =
                    (siteMap.$el && siteMap.$el.offsetHeight) || 0;
                const xRatio = (mapBounds[1] - mapBounds[0]) / mapWidth;
                const yRatio = (mapBounds[3] - mapBounds[2]) / mapHeight;
                const pos = {
                    top: -Math.round((+this.lat - mapBounds[3]) / yRatio),
                    left: Math.round((+this.lng - mapBounds[0]) / xRatio),
                    bottom: Math.round((+this.lat - mapBounds[2]) / yRatio),
                    right: -Math.round((+this.lng - mapBounds[1]) / xRatio)
                };
                if ($pop && $pop.offsetWidth > mapWidth - 30) {
                    popStyle.whiteSpace = 'normal';
                    popStyle.maxWidth = mapWidth - 30 + 'px';
                    popStyle.width = 'max-content';
                }
                const width = ($pop && $pop.offsetWidth / 2) || 0;
                const height = ($pop && $pop.offsetHeight) || 0;
                const ctWidth = this.$refs?.markerRef?.offsetWidth / 2;
                const ctHeight = this.$refs?.markerRef?.offsetHeight / 2;
                const popHeight = height + ctHeight + 10;
                if (pos.top < popHeight) {
                    if (pos.bottom < popHeight) {
                        const currentCenterPoint = map.getCenter();
                        let lat = 0;
                        if (pos.top > pos.bottom) {
                            lat = popHeight - pos.top;
                            this.popBottom = false;
                        } else {
                            lat = pos.bottom - popHeight;
                            this.popBottom = true;
                        }
                        //  there is a problem here   https://jira.chimeinc.com/browse/CHIME-15388
                        map.setCenter({
                            lat: currentCenterPoint.lat + lat * yRatio,
                            lng: currentCenterPoint.lng
                        });
                    } else {
                        this.popBottom = true;
                    }
                } else {
                    this.popBottom = false;
                }

                let left = '';
                if (width > pos.left) {
                    left = ctWidth + width - pos.left + 10 + 'px';
                } else if (width > pos.right) {
                    left = ctWidth + pos.right - width - 10 + 'px';
                }
                popStyle.left = left;

                if ($pointer) {
                    if (left === '') {
                        pointerStyle.left = '';
                    } else {
                        const minLeft = $pointer.offsetWidth / 2 + 2;
                        pointerStyle.left =
                            Math.min(
                                width * 2 - minLeft,
                                Math.max(minLeft, width + ctWidth - left)
                            ) + 'px';
                    }
                }
                this.popStyle = popStyle;
                this.pointerStyle = pointerStyle;
            });
        },
        onMouseEnter() {
            this.$emit('update:active', this.fmLatlng);
            const mouseEnterEvent = this.events && this.events.mouseEnter;
            mouseEnterEvent && mouseEnterEvent.call(this);
        },
        onMouseLeave() {
            this.$emit('update:active', '');
            const mouseLeaveEvent = this.events && this.events.mouseLeave;
            mouseLeaveEvent && mouseLeaveEvent.call(this);
        },
        onClick: util.debounce(function() {
            this.$emit('update:active', this.fmLatlng);
            const clickEvent = this.events && this.events.click;
            clickEvent && clickEvent.call(this, this.data);
        }, 400),
        getData(isOrigin) {
            if (isOrigin) {
                return this.data.originData;
            } else {
                return this.data;
            }
        }
    }
};
